import { i18n as _i18n } from "@lingui/core";
import { formNames } from '@wkda/carlead-creation-form';
import cx from 'classnames';
import { useField } from 'react-final-form';
import { useIsStepEnabled } from '../FormsStateMachine/stateSelectors';
import { useCarleadFieldChangedTracking } from '../hooks/useCarleadFieldChangedTracking';
import { BaseField } from './BaseField';
import { checkboxRenderer } from './fieldRenderers/checkboxRenderer';
import { usePreviousValuesForField } from './hooks/useStateMachineForFields';
import { jsx as _jsx } from "react/jsx-runtime";
export function EmailConsent(_ref) {
  let {
    label = _i18n._(
    /*i18n*/
    {
      id: 'carleadCreation.form.label.emailConsent'
    }),
    className,
    onChange,
    renderHeader = () => /*#__PURE__*/_jsx("div", {
      className: "carlead-creation-field__label"
    }),
    ...props
  } = _ref;
  const name = formNames.EMAIL_EVALUATION_CONSENT;
  const {
    allPreviousHaveValues
  } = usePreviousValuesForField('email');
  const isEmailEnabled = useIsStepEnabled('email') || allPreviousHaveValues;
  const trackLeadFieldChanged = useCarleadFieldChangedTracking();
  const {
    input
  } = useField(name);
  return /*#__PURE__*/_jsx(BaseField, {
    name: name,
    topContainerClassName: cx({
      'carlead-creation-field-container--is-disabled': !isEmailEnabled,
      'carlead-creation-field-container--has-value': input.value
    }),
    renderHeader: renderHeader,
    MktSelector: {
      value: name,
      group: false
    },
    type: "checkbox",
    disabled: !isEmailEnabled,
    renderFieldComponent: function fieldRenderer(_ref2) {
      let {
        name,
        mktSelector,
        ...rest
      } = _ref2;
      return /*#__PURE__*/_jsx("div", {
        className: "email-consent-field",
        children: checkboxRenderer({
          name,
          label,
          mktSelector,
          className,
          inputProps: {
            disabled: !isEmailEnabled,
            onChange(evt) {
              onChange?.(evt);
              trackLeadFieldChanged(name, 'user');
            },
            autoComplete: 'off',
            ...rest
          }
        })
      });
    },
    ...props
  });
}